import inventoryApi from "@/api/inventory";

const state = {
    items: [],
    totalHas: 0,
    jewelryItems: [],
    jewelryTotalHas: 0,
};

const getters = {
    items: state => state.items,
    totalHas: state => state.totalHas,
    jewelryItems: state => state.jewelryItems,
    jewelryTotalHas: state => state.jewelryTotalHas,
};

const actions = {
    getInventoryItems: async (context, type) => {
        const d = (await inventoryApi.getInventoryItems(type)).data;
        context.commit("setItems", d);
        return d;
    },
    getTotalHas: async (context) => {
        const d = (await inventoryApi.getTotalHas()).data;
        context.commit("setTotalHas", d);
        return d;
    },
    addKulce: async (context, dto) => {
        const d = (await inventoryApi.addKulce(dto)).data;
        return d;
    },
    addZiynet: async (context, dto) => {
        const d = (await inventoryApi.addZiynet(dto)).data;
        return d;
    },
    addTaki: async (context, dto) => {
        const d = (await inventoryApi.addTaki(dto)).data;
        return d;
    },
    getJewelryItems: async (context, { status, search, size, weightRounded, purity } = {}) => {
        const d = (await inventoryApi.getJewelryItems(status, search, size, weightRounded, purity)).data;
        context.commit("setJewelryItems", d);
        return d;
    },
    getJewelryTotalHas: async (context, { status, size, weightRounded, purity } = {}) => {
        const d = (await inventoryApi.getJewelryTotalHas(status, size, weightRounded, purity)).data;
        context.commit("setJewelryTotalHas", d);
        return d;
    },
    deleteJewelryItem: async (context, id) => {
        await inventoryApi.deleteJewelryItem(id);
    },
    updateJewelryStatus: async (context, { id, dto }) => {
        await inventoryApi.updateJewelryStatus(id, dto);
    },
};

const mutations = {
    setItems(state, items) {
        state.items = items;
    },
    setTotalHas(state, totalHas) {
        state.totalHas = totalHas;
    },
    setJewelryItems(state, items) {
        state.jewelryItems = items;
    },
    setJewelryTotalHas(state, totalHas) {
        state.jewelryTotalHas = totalHas;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
